module.exports = __webpack_public_path__ + "img/kyc.31134762.png";